var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeSlider'),_c('InfoSlider',{attrs:{"title":"Wij zijn een <b>top</b> interieur bedrijf met een passie voor design."}}),_c('TextWidget'),_c('FeaturedPortfolio'),_c('ContactForm'),_c('FooterPeeters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }